import { cn } from '@/utils/cn';

interface BillProviderIconProps {
  logoUrl?: string | null;
  fallbackColor?: string;
  fallbackInitial: string;
  alt?: string;
  size?: 'sm' | 'md' | 'lg';
}

export function BillProviderIcon({
  logoUrl,
  fallbackColor = 'bg-gray-500',
  fallbackInitial,
  alt = 'Provider',
  size = 'md',
}: BillProviderIconProps) {
  const sizeClass =
    size === 'lg' ? 'h-11 w-11 text-sm' : size === 'sm' ? 'h-7 w-7 text-[10px]' : 'h-9 w-9 text-xs';

  return (
    <div
      className={cn(
        'flex shrink-0 items-center justify-center overflow-hidden rounded-full border border-gray-100 bg-white p-1 shadow-sm',
        sizeClass,
      )}
    >
      {logoUrl ? (
        <img src={logoUrl} alt={alt} className="h-full w-full object-contain" />
      ) : (
        <div
          className={cn(
            'flex h-full w-full items-center justify-center rounded-full font-bold text-white',
            fallbackColor,
          )}
        >
          {fallbackInitial.slice(0, 3)}
        </div>
      )}
    </div>
  );
}
